exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".youtube-video {\n  width: 100%;\n  height: 100%;\n}\n.youtube-video iframe {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
